import { useNavigate } from "react-router-dom";
import { useSharedState } from "state";
import {
  IconBooks,
  IconClipboardList,
  IconClipboardText,
  IconFiles,
  IconLayoutKanban,
  IconLogout2,
  IconMoon,
  IconPasswordUser,
  IconReceipt,
  IconReport,
  IconSettings,
  IconSun,
  IconTemplate,
  IconUser,
  IconUsers,
} from "@tabler/icons-react";
import ChangePassword from "components/auth/change-password";
import DangerModal from "components/modal/danger";
import LogoTitle from "assets/img/dock_title.png";

export default function VerticalNavbar() {
  const { darkMode, setDarkMode, user, logout, isAdmin, sidebarCounters } = useSharedState();

  const navigate = useNavigate();

  const pathname = window.location.pathname;

  const changeTheme = () => {
    if (darkMode) {
      localStorage.setItem("tablerTheme", "light");
      setDarkMode(false);
    } else {
      localStorage.setItem("tablerTheme", "dark");
      setDarkMode(true);
    }
  };

  return (
    <>
      <aside className="navbar navbar-vertical navbar-expand-lg">
        <div className="container-fluid">
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#sidebar-menu"
            aria-controls="sidebar-menu"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <h1 className="navbar-brand navbar-brand-autodark">
            <img src={LogoTitle} height="36" alt="" />
          </h1>
          <div className="navbar-nav flex-row d-lg-none">
            <div className="d-flex">
              <div onClick={changeTheme} className="nav-link px-0 hide-theme-dark cursor-pointer">
                <IconMoon className="icon" />
              </div>
              <div onClick={changeTheme} className="nav-link px-0 hide-theme-light cursor-pointer">
                <IconSun className="icon" />
              </div>
            </div>
          </div>
          <div className="collapse navbar-collapse" id="sidebar-menu">
            <ul className="navbar-nav">
              <li className="nav-item disabled">
                <div className="nav-link">
                  <span className="nav-link-icon d-lg-inline-block">
                    <IconUser className="icon" />
                  </span>
                  <span className="nav-link-title">{user.result.name || "-"}</span>
                </div>
              </li>

              <li className={`nav-item dropdown ${pathname === "/tasks" && "active"}`}>
                <div
                  className="nav-link dropdown-toggle show"
                  data-bs-toggle="dropdown"
                  data-bs-auto-close="false"
                  role="button"
                  aria-expanded="true"
                >
                  <span className="nav-link-icon d-lg-inline-block">
                    <IconLayoutKanban className="icon" />
                  </span>
                  <span className="nav-link-title">Задачи</span>
                </div>
                <div className="dropdown-menu show">
                  <div className="dropdown-menu-columns">
                    <div className="dropdown-menu-column">
                      <div
                        className={`dropdown-item cursor-pointer ${
                          pathname === "/tasks" && !window.location.search.includes("type=other") && "active"
                        }`}
                        onClick={() => navigate("/tasks")}
                      >
                        <span className="nav-link-icon d-lg-inline-block">
                          <IconUser className="icon" />
                        </span>
                        <span className="nav-link-title">Мои задачи</span>
                        <span className="badge badge-sm bg-green-lt text-uppercase ms-auto">
                          {sidebarCounters?.task_approval_for_me || 0}
                        </span>
                      </div>

                      <div
                        className={`dropdown-item cursor-pointer ${
                          pathname === "/tasks" && window.location.search.includes("type=other") && "active"
                        }`}
                        onClick={() => navigate("/tasks?type=other")}
                      >
                        <span className="nav-link-icon d-lg-inline-block">
                          <IconUsers className="icon" />
                        </span>
                        <span className="nav-link-title">Другие задачи</span>
                        <span className="badge badge-sm bg-green-lt text-uppercase ms-auto">
                          {sidebarCounters?.task_approval_for_others || 0}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </li>

              {user.result.document_approval_access && (
                <li
                  className={`nav-item dropdown cursor-pointer ${pathname === "/documents" && "active"}`}
                  onClick={() => navigate("/documents")}
                >
                  <div className="nav-link">
                    <span className="nav-link-icon d-lg-inline-block">
                      <IconFiles className="icon" />
                    </span>
                    <span className="nav-link-title">Договоры</span>
                    <span className="badge badge-sm bg-green-lt text-uppercase ms-auto">
                      {sidebarCounters?.document_approval_count || 0}
                    </span>
                  </div>
                </li>
              )}

              {user.result.payment_approval_access && (
                <li
                  className={`nav-item dropdown cursor-pointer ${pathname === "/payments" && "active"}`}
                  onClick={() => navigate("/payments")}
                >
                  <div className="nav-link">
                    <span className="nav-link-icon d-lg-inline-block">
                      <IconReceipt className="icon" />
                    </span>
                    <span className="nav-link-title">Оплаты</span>
                    <span className="badge badge-sm bg-green-lt text-uppercase ms-auto">
                      {sidebarCounters?.payment_approval_count || 0}
                    </span>
                  </div>
                </li>
              )}

              {user.result.budget_access && (
                <li className={`nav-item dropdown ${(pathname === "/budgets" || pathname === "/reports") && "active"}`}>
                  <div
                    className="nav-link dropdown-toggle show"
                    data-bs-toggle="dropdown"
                    data-bs-auto-close="false"
                    role="button"
                    aria-expanded="true"
                  >
                    <span className="nav-link-icon d-lg-inline-block">
                      <IconClipboardText className="icon" />
                    </span>
                    <span className="nav-link-title">Бюджеты</span>
                  </div>
                  <div className="dropdown-menu show">
                    <div className="dropdown-menu-columns">
                      <div className="dropdown-menu-column">
                        <div
                          className={`dropdown-item cursor-pointer ${pathname === "/budgets" && "active"}`}
                          onClick={() => navigate("/budgets")}
                        >
                          <span className="nav-link-icon d-lg-inline-block">
                            <IconClipboardList className="icon" />
                          </span>
                          <span className="nav-link-title">Бюджеты отделов</span>
                        </div>

                        <div
                          className={`dropdown-item cursor-pointer ${pathname === "/reports" && "active"}`}
                          onClick={() => navigate("/reports")}
                        >
                          <span className="nav-link-icon d-lg-inline-block">
                            <IconReport className="icon" />
                          </span>
                          <span className="nav-link-title">Отчёты</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              )}

              {isAdmin && (
                <li className="nav-item dropdown">
                  <div
                    className="nav-link dropdown-toggle"
                    data-bs-toggle="dropdown"
                    data-bs-auto-close="false"
                    role="button"
                    aria-expanded="true"
                  >
                    <span className="nav-link-icon d-lg-inline-block">
                      <IconBooks className="icon" />
                    </span>
                    <span className="nav-link-title">Справочники</span>
                  </div>
                  <div className="dropdown-menu">
                    <div className="dropdown-menu-columns">
                      <div className="dropdown-menu-column">
                        <div
                          className={`dropdown-item cursor-pointer ${pathname === "/users" && "active"}`}
                          onClick={() => navigate("/users")}
                        >
                          <span className="nav-link-icon d-lg-inline-block">
                            <IconUsers className="icon" />
                          </span>
                          <span className="nav-link-title">Пользователи</span>
                        </div>

                        <div
                          className={`dropdown-item cursor-pointer ${pathname === "/templates" && "active"}`}
                          onClick={() => navigate("/templates")}
                        >
                          <span className="nav-link-icon d-lg-inline-block">
                            <IconTemplate className="icon" />
                          </span>
                          <span className="nav-link-title">Шаблоны</span>
                        </div>

                        <div
                          className={`dropdown-item cursor-pointer ${pathname === "/contractors" && "active"}`}
                          onClick={() => navigate("/contractors")}
                        >
                          <span className="nav-link-icon d-lg-inline-block">
                            <IconTemplate className="icon" />
                          </span>
                          <span className="nav-link-title">Контрагенты</span>
                        </div>

                        <div
                          className={`dropdown-item cursor-pointer ${pathname === "/levels" && "active"}`}
                          onClick={() => navigate("/levels")}
                        >
                          <span className="nav-link-icon d-lg-inline-block">
                            <IconTemplate className="icon" />
                          </span>
                          <span className="nav-link-title">Уровни</span>
                        </div>

                        <div
                          className={`dropdown-item cursor-pointer ${pathname === "/codes" && "active"}`}
                          onClick={() => navigate("/codes")}
                        >
                          <span className="nav-link-icon d-lg-inline-block">
                            <IconTemplate className="icon" />
                          </span>
                          <span className="nav-link-title">Коды ИТ</span>
                        </div>

                        <div
                          className={`dropdown-item cursor-pointer ${pathname === "/formulas" && "active"}`}
                          onClick={() => navigate("/formulas")}
                        >
                          <span className="nav-link-icon d-lg-inline-block">
                            <IconTemplate className="icon" />
                          </span>
                          <span className="nav-link-title">Формулы</span>
                        </div>

                        <div
                          className={`dropdown-item cursor-pointer ${pathname === "/constructor" && "active"}`}
                          onClick={() => navigate("/constructor")}
                        >
                          <span className="nav-link-icon d-lg-inline-block">
                            <IconTemplate className="icon" />
                          </span>
                          <span className="nav-link-title">Конструктор</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              )}

              <li className="nav-item dropdown">
                <div
                  className="nav-link dropdown-toggle"
                  data-bs-toggle="dropdown"
                  data-bs-auto-close="false"
                  role="button"
                  aria-expanded="true"
                >
                  <span className="nav-link-icon d-lg-inline-block">
                    <IconSettings className="icon" />
                  </span>
                  <span className="nav-link-title">Настройки</span>
                </div>
                <div className="dropdown-menu">
                  <div className="dropdown-menu-columns">
                    <div className="dropdown-menu-column">
                      <div
                        className="dropdown-item cursor-pointer"
                        data-bs-toggle="modal"
                        data-bs-target="#modal-password"
                      >
                        <span className="nav-link-icon d-lg-inline-block">
                          <IconPasswordUser className="icon" />
                        </span>
                        <span className="nav-link-title">Сменить пароль</span>
                      </div>

                      <div className="dropdown-item d-except-lg cursor-pointer" onClick={changeTheme}>
                        <span className="nav-link-icon d-lg-inline-block px-0 hide-theme-dark">
                          <IconMoon className="icon" />
                        </span>
                        <span className="nav-link-icon d-lg-inline-block px-0 hide-theme-light">
                          <IconSun className="icon" />
                        </span>
                        <span className="nav-link-title">Сменить тему</span>
                      </div>

                      <div
                        className="dropdown-item cursor-pointer"
                        data-bs-toggle="modal"
                        data-bs-target="#modal-logout"
                      >
                        <span className="nav-link-icon d-lg-inline-block">
                          <IconLogout2 className="icon" color="#d93939" />
                        </span>
                        <span className="nav-link-title text-danger">Выйти из системы</span>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </aside>

      <ChangePassword />
      <DangerModal
        modal_id="modal-logout"
        dangerDescription="Вы действительно хотите выйти из учётной записи?"
        cancel={() => undefined}
        confirm={logout}
      />
    </>
  );
}
